<script setup lang="ts">

import {onMounted, ref} from "vue";
import Quill from 'quill'
import {QuillyEditor} from "vue-quilly";
import {QuillOptions} from "quill/core";

interface Props {
    placeholder?: string
    class?: string
}

const props = withDefaults(defineProps<Props>(), {
    placeholder: '',
    class: '',
})

const value = defineModel<string|null>()

const options: QuillOptions = {
    theme: 'snow',
    modules: {
        toolbar: true
    },
    placeholder: props.placeholder,
    readOnly: false
}

const editor = ref<InstanceType<typeof QuillyEditor>>()
let quill: Quill | null = null

onMounted(() => {
    if (editor.value) {
        quill = editor.value.initialize(Quill)
    }
})
</script>

<template>
    <div
        class="border-sm rounded-lg border-black"
    >
        <QuillyEditor
            ref="editor"
            v-model="value"
            style="min-height: 100px;"
            :options="options"
        />
    </div>
</template>

<style scoped>
:deep(.ql-editor.ql-blank::before) {
    font-style: normal;
    font-family: monospace;
}

.border-black {
    border-color: black !important;
}

:deep(.ql-tooltip) {
    z-index: 10000 !important;
}
</style>
